export const UPCOMING_EVENTS = "UPCOMING_EVENTS";
export const UPCOMING_EVENTS_ERROR = "UPCOMING_EVENTS_ERROR";
export const UPCOMING_EVENTS_HIDE_ERROR = "UPCOMING_EVENTS_HIDE_ERROR";
export const UPCOMING_EVENTS_START_LOADER = "UPCOMING_EVENTS_START_LOADER";
export const UPCOMING_EVENTS_STOP_LOADER = "UPCOMING_EVENTS_STOP_LOADER";
